const featureToggles = {
  savedJobs: true,
};

export default featureToggles;
